import { isDeliverToFulfillmentCenter } from './is-deliver-to-fulfillment-center.util';
import { isOrderSplitShipped } from './is-order-split-shipped';
export function isFirstInventoryOrder(order) {
  return !order.orderForCustomStore && isDeliverToFulfillmentCenter(order) && Boolean(order === null || order === void 0 ? void 0 : order.isFirstInventoryOrder) || isOrderSplitShipped(order) && Boolean(order === null || order === void 0 ? void 0 : order.isFirstInventoryOrder);
}